import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import cx from 'classnames';

import { AccordionItem } from '@nextiva/next-ui';

import { Accordion } from '../Accordion';
import { Spinner } from '../Spinner';
import styles from './entitiesListStyles.module.scss';

export const EntitiesList = props => {
  return (
    <Accordion
      openItems={props.openItems}
      timeline={false}
      onClick={props.onClick}
    >
      <AccordionItem label={props.heading} wideDecorate={false} hideBar={false}>
        {props.items ? (
          <ul className={styles.itemsList}>
            {map(props.items.data, item => (
              <li
                key={item.id}
                className={cx(styles.itemStyles, {
                  [styles.itemStylesSelected]: item.id === props.selectedItemId,
                })}
                onClick={() => props.onItemClick(item)}
              >
                {item.attributes[props.titleKey]}
              </li>
            ))}
          </ul>
        ) : (
          <Spinner className={styles.spinner} />
        )}
      </AccordionItem>
    </Accordion>
  );
};

EntitiesList.propTypes = {
  items: PropTypes.object,
  openItems: PropTypes.object,
  selectedItemId: PropTypes.string,
  heading: PropTypes.string,
  titleKey: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
};
